import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider, createRouter } from '@tanstack/react-router'
import { TanStackRouterDevtools } from '@tanstack/router-devtools'
// Add to your main app file
import { setupOktaInterceptor } from './utils/okta-interceptor'

// Import the generated route tree
import { routeTree } from './routeTree.gen'

import './index.css'
import './localization'
import { initializeNewRelic } from './utils/newrelic'

// Create a new router instance
const router = createRouter({
  routeTree,
  context: {
    scrollToTop: () => window.scrollTo(0, 0),
  },
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

// Initialize New Relic
initializeNewRelic()
setupOktaInterceptor()

const rootElement = document.getElementById('root') as HTMLElement
const root = createRoot(rootElement)

root.render(
  <StrictMode>
    <RouterProvider router={router} />
    {process.env.NODE_ENV === 'development' && <TanStackRouterDevtools router={router} />}
  </StrictMode>
)
